(() => {
  if (customElements.get('menasa-header')) return;
  if (!window.MenasaScrollLock) {
    const owners=new Set(); let previous='';
    window.MenasaScrollLock={
      acquire(owner){if(owners.has(owner))return;if(!owners.size){previous=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden'}owners.add(owner)},
      release(owner){if(!owners.delete(owner))return;if(!owners.size)document.documentElement.style.overflow=previous}
    };
  }

  class MenasaHeader extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const on = (target, event, handler) => target?.addEventListener(event, handler, { signal: this.abort.signal });
      this.menu = this.querySelector('#MobileMenu');
      this.search = this.querySelector('#SearchOverlay');
      this.menuToggle = this.querySelector('#MobileToggle');
      this.header = this.querySelector('#PrestigeHeader');
      if (this.header && !this.header.querySelector('.site-header__glass')) {
        const glass=document.createElement('div');
        glass.className='site-header__glass';glass.setAttribute('aria-hidden','true');
        const tier=window.MenasaQuality?.tier;
        // Phones get no backdrop blur: it is redrawn on the GPU every frame the page moves under it.
        const count=['light','reduced'].includes(tier)||window.MenasaQuality?.phone||window.MenasaQuality?.noBlur?0:tier==='balanced'?2:8;
        for(let i=0;i<count;i++){
          const slice=document.createElement('i');
          const start=i*100/count, end=(i+1)*100/count;
          slice.style.setProperty('--slice-blur',`${(count===2?9:14)*(1-i/count)**1.3}px`);
          // Feather adjacent levels over a full band; no hard horizontal clip edges.
          const stops=[i ? `transparent ${Math.max(0,start-100/count)}%` : '#000 0%',
            `#000 ${start}%`, `#000 ${end}%`, `transparent ${Math.min(100,end+100/count)}%`];
          slice.style.setProperty('--blur-mask',`linear-gradient(to bottom,${stops.join(',')})`);
          glass.append(slice);
        }
        this.header.prepend(glass);
      }
      on(document,'menasa:quality',()=>{this.header.querySelector('.site-header__glass')?.remove();this.connectedCallback()});
      // The header stays mounted across the site's page transitions, so its "current page" underline is set again for
      // each page shown (Liquid's link.active only knew the page the visit started on).
      const markCurrent=()=>{
        const here=location.pathname.replace(/\/$/,'')||'/';
        this.querySelectorAll('.nav-link[href],.nav-dropdown-link[href]').forEach(link=>{
          const path=new URL(link.href,location.href).pathname.replace(/\/$/,'')||'/';
          link.classList.toggle('is-active',path===here||(path!=='/'&&/^\/(collections|blogs)/.test(path)&&here.startsWith(path+'/')));
        });
      };
      on(document,'menasa:page',markCurrent);
      on(window,'popstate',()=>requestAnimationFrame(markCurrent));
      this.searchToggle = this.querySelector('#SearchToggle');
      this.input = this.querySelector('#SearchInput');
      this.results = this.querySelector('#PredictiveResults');
      this.list = this.querySelector('#PredictiveList');
      if (!this.menu || !this.search || !this.input) return;

      on(this.menuToggle, 'click', () => this.open(this.menu, this.menuToggle));
      on(this.searchToggle, 'click', () => this.open(this.search, this.searchToggle));
      on(this.querySelector('#MobileClose'), 'click', () => this.close());
      on(this.querySelector('#SearchClose'), 'click', () => this.close());
      const followLink = event => {
        const link = event.target.closest('a[href]');
        if (!link) return;
        const url = new URL(link.href, location.href);
        const samePage = url.origin === location.origin && url.pathname === location.pathname && url.search === location.search;
        let target = null;
        if (samePage && url.hash) {
          try { target = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch (_error) {}
        }
        this.close(samePage && !target);
        if (target) {
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          requestAnimationFrame(() => target.focus({ preventScroll: true }));
        }
      };
      on(this.menu, 'click', followLink);
      on(this.header, 'click', event => {
        if (this.activeDialog && event.target.closest('a[href]')) {
          this.close(false);
        }
      });
      on(this.search, 'click', followLink);
      on(this.input, 'input', () => this.suggest());
      on(document, 'keydown', event => {
        if (!this.activeDialog) return;
        if (event.key === 'Escape') { event.preventDefault(); this.close(); }
        if (event.key !== 'Tab') return;
        const items = [...(this.activeDialog===this.menu?[...this.header.querySelectorAll('a[href],button:not([disabled])')]:[]), ...this.activeDialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]')]
          .filter(item => item.getClientRects().length);
        const first = items[0];
        const last = items[items.length - 1];
        if (!first) { event.preventDefault(); this.activeDialog.focus(); return; }
        if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !items.includes(document.activeElement))) {
          event.preventDefault(); first.focus();
        }
      });
      on(document, 'focusin', event => {
        if (this.activeDialog && !this.activeDialog.contains(event.target) && !(this.activeDialog===this.menu && this.header.contains(event.target))) this.focusDialog();
      });
      on(window.matchMedia('(min-width: 1025px)'), 'change', event => {
        if (event.matches && this.activeDialog === this.menu) this.close();
      });
      this.querySelectorAll('.nav-item-dropdown').forEach(wrap => {
        const trigger = wrap.querySelector('.nav-link-parent');
        const expanded = value => trigger?.setAttribute('aria-expanded', String(value));
        on(wrap, 'mouseenter', () => expanded(true));
        on(wrap, 'mouseleave', () => expanded(wrap.contains(document.activeElement)));
        on(wrap, 'focusin', () => expanded(true));
        on(wrap, 'focusout', event => expanded(wrap.contains(event.relatedTarget)));
      });
    }

    focusDialog() {
      const target = this.activeDialog === this.search ? this.input : this.menuToggle;
      (target || this.activeDialog)?.focus({ preventScroll: true });
    }

    open(dialog, trigger) {
      if (this.activeDialog === dialog) { this.close(); return; }
      this.close(false);
      clearTimeout(this.menuCloseTimer);
      this.classList.remove('menu-closing');
      this.returnFocus = trigger;
      this.activeDialog = dialog;
      dialog.classList.add('is-open');
      dialog.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      this.menuToggle.classList.toggle('is-active', dialog === this.menu);
      this.classList.toggle('has-menu', dialog === this.menu);
      this.menuToggle.setAttribute('aria-label',dialog===this.menu?'Close menu':'Open menu');
      window.MenasaScrollLock.acquire(this);
      this.focusFrame = requestAnimationFrame(() => {
        this.focusFrame = requestAnimationFrame(() => {
          if (this.activeDialog === dialog) this.focusDialog();
        });
      });
    }

    close(restoreFocus = true) {
      if (!this.activeDialog) return;
      cancelAnimationFrame(this.focusFrame);
      this.activeDialog.classList.remove('is-open');
      this.activeDialog.setAttribute('aria-hidden', 'true');
      this.activeDialog = null;
      this.classList.add('menu-closing');
      this.menuToggle.classList.remove('is-active');
      this.menuToggle.setAttribute('aria-label','Open menu');
      clearTimeout(this.menuCloseTimer);
      this.menuCloseTimer=setTimeout(()=>this.classList.remove('has-menu','menu-closing'),matchMedia('(prefers-reduced-motion: reduce)').matches?0:760);
      this.menuToggle.setAttribute('aria-expanded', 'false');
      this.searchToggle.setAttribute('aria-expanded', 'false');
      window.MenasaScrollLock.release(this);
      clearTimeout(this.timer);
      this.request?.abort();
      this.results.style.display = 'none';
      this.list.replaceChildren();
      this.input.value = '';
      if (restoreFocus && this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
    }

    suggest() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.results.style.display = 'none';
      const query = this.input.value.trim();
      if (query.length < 3) return;
      this.timer = setTimeout(async () => {
        this.request = new AbortController();
        const request = this.request;
        const url = new URL(this.dataset.suggestUrl + '.json', location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '4');
        let products = [];
        try {
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) throw new Error('Search unavailable');
          const body = await response.json();
          products = body.resources?.results?.products || [];
        } catch (error) {
          if (error.name === 'AbortError') return;
        }
        if (request.signal.aborted || this.activeDialog !== this.search || this.input.value.trim() !== query) return;
        this.list.replaceChildren();
        products.forEach(product => {
          const li = document.createElement('li');
          const link = document.createElement('a');
          link.className = 'predictive-item';
          link.href = product.url;
          if (product.image) {
            const image = document.createElement('img');
            image.src = product.image;
            image.alt = '';
            link.append(image);
          }
          const title = document.createElement('span');
          title.className = 'predictive-item-title';
          title.textContent = product.title;
          link.append(title);
          li.append(link);
          this.list.append(li);
        });
        const li = document.createElement('li');
        const link = document.createElement('a');
        const searchUrl = new URL(this.dataset.searchUrl, location.origin);
        searchUrl.searchParams.set('q', query);
        link.href = searchUrl.pathname + searchUrl.search;
        link.textContent = `View all results for “${query}”`;
        li.append(link);
        this.list.append(li);
        this.results.style.display = 'block';
      }, 250);
    }

    disconnectedCallback() {
      this.close(false);
      this.abort?.abort();
      this.request?.abort();
      clearTimeout(this.timer);
      clearTimeout(this.menuCloseTimer);
      this.classList.remove('has-menu');
    }
  }
  customElements.define('menasa-header', MenasaHeader);
})();
